import {InputField} from "./Decorators";

export class UserWoClient {

    _inputFields: any;

    felhasznalo_id: number = 0;
    @InputField({required: true}) nev: string = "";
    email: string = "";
    @InputField({required: true}) password: string = "";
    @InputField({required: true}) passwordre: string = "";

}
